import React, { useState } from 'react'

import reactQuery from '../../_helpers/reactQuery'
import { supplierService } from '../../_services'
import translate from '../../locales/en'
import Document from '../Abstract/Document'

const Supplier = function () {
  const collectionName = 'Suppliers'
  const singleCollectionName = 'Supplier'
  const queryKey = collectionName.toLowerCase()
  const [body, setBody] = useState({})
  const defaultQueryParams = {}
  const [queryParams, setQueryParams] = useState(defaultQueryParams)
  const getQuery = reactQuery.getQuery(
    queryKey,
    queryParams,
    supplierService.getSuppliers
  )
  const createMutation = reactQuery.createMutation(
    supplierService.createSupplier,
    singleCollectionName,
    queryKey
  )
  return (
    <Document
      tableActions={[
        {
          buttonLabel: `${translate.Add} ${translate[singleCollectionName]}`,
          buttonColor: 'primary',
          onSubmit: (args) => createMutation.mutate(args),
          body,
          setBody,
          withClear: true,
          clearFunction: () => setBody({}),
          form: {
            title: `${translate.Add} ${translate[singleCollectionName]}`,
            inputs: [
              {
                name: 'name',
                label: 'Name',
                type: 'text',
                required: true,
              },
              {
                name: 'phoneNumber',
                label: 'Phone Number',
                type: 'text',
              },
              {
                name: 'note',
                label: 'Note',
                type: 'text',
              },
            ],
          },
        },
      ]}
      title={collectionName}
      getQuery={getQuery}
      queryKey={queryKey}
      defaultQueryParams={defaultQueryParams}
      queryParams={queryParams}
      setQueryParams={setQueryParams}
      many
    />
  )
}
export default Supplier
